import PropTypes from "prop-types";
import { getStepStates } from "./statusFlow";

/*
 * The order document carries one timestamp (`createdAt`) and the current
 * `status`; there is no per-event history endpoint. So the log shows the
 * stages the order has genuinely reached, newest first, and dates only the
 * event we actually have a time for rather than inventing any.
 */
const ActivityLog = ({ status, createdAt, trackId, shippingMethod }) => {
  const reached = getStepStates(status).filter((step) => !step.pending);

  const detail = {
    confirmed: "Payment authorised and your order confirmation was emailed.",
    processing: "Your items are being picked and packed at our warehouse.",
    dispatched: shippingMethod
      ? `Handed to the carrier via ${shippingMethod}.`
      : "Your parcel has been handed to the carrier.",
    delivered: "Your parcel was delivered.",
  };

  const placed = createdAt ? new Date(createdAt) : null;

  const entries = reached
    .map((step) => ({
      key: step.key,
      title: step.label,
      text:
        step.key === "dispatched" && trackId
          ? `${detail.dispatched} Tracking number ${trackId}.`
          : detail[step.key],
      time: null,
    }))
    .reverse();

  entries.push({
    key: "placed",
    title: "Order placed",
    text: "Your order was received and added to the fulfilment queue.",
    time: placed,
  });

  return (
    <section className="c4trk__log-wrap" aria-labelledby="c4trk-log-heading">
      <h2 className="c4trk__card-title" id="c4trk-log-heading">
        Activity Log
      </h2>

      <ol className="c4trk__log">
        {entries.map((entry, index) => (
          <li
            className={`c4trk__log-item${
              index === 0 ? " c4trk__log-item--latest" : ""
            }`}
            key={entry.key}
          >
            <span className="c4trk__log-dot" aria-hidden="true" />
            <div className="c4trk__log-body">
              {entry.time ? (
                <time
                  className="c4trk__log-time"
                  dateTime={entry.time.toISOString()}
                >
                  {entry.time.toLocaleDateString(undefined, {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                  {" · "}
                  {entry.time.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </time>
              ) : null}
              <p className="c4trk__log-title">{entry.title}</p>
              <p className="c4trk__log-text">{entry.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

ActivityLog.propTypes = {
  status: PropTypes.string,
  createdAt: PropTypes.string,
  trackId: PropTypes.string,
  shippingMethod: PropTypes.string,
};

export default ActivityLog;
